import { root, setupServiceInfo, getModuleFederatedName } from '@estee/elc-universal-utils';
import { EcommApp } from './service-setup/EcommApp';

setupServiceInfo(__serviceInfo__);

const { name, version } = __serviceInfo__;

EcommApp.setViews(name, getModuleFederatedName(name), version, []);

(root as Window).EcommApp = EcommApp;
